<template>
  <div>
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
    </div>
    <div class="text-operations"></div>

    <div class="panel-head">
      <h3>Generación de reporte de mantenimiento de unidades</h3>
      <img src="@/assets/filtros.png" alt="filtros" />
    </div>

    <form class="filters-card" @submit.prevent="generateReport">
      <div class="row">
        <label for="start_date">Fecha</label>
        <input id="start_date" type="date" v-model="startDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
        <span class="sep">al</span>
        <input id="end_date" type="date" v-model="endDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
      </div>

      <div class="row">
        <label for="unit_category">Categoría</label>
        <select id="unit_category" v-model="unitCategory" class="form-select">
          <option value="">Todas</option>
          <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.label }}</option>
        </select>
        <span class="sep"></span>
        <div class="cell"></div>
      </div>

      <div class="row">
        <label for="motive">Motivo</label>
        <select id="motive" v-model="motiveOfService" class="form-select">
          <option value="">Todos</option>
          <option v-for="motive in motives" :key="motive" :value="motive">{{ motive }}</option>
        </select>
        <span class="sep"></span>
        <div class="cell"></div>
      </div>

      <div class="row">
        <label for="cause">Causa</label>
        <select id="cause" v-model="cause" class="form-select">
          <option value="">Todas</option>
          <option v-for="item in causes" :key="item" :value="item">{{ item }}</option>
        </select>
        <span class="sep"></span>
        <div class="cell"></div>
      </div>

      <div class="row">
        <label for="severity">Severidad</label>
        <select id="severity" v-model="repairSeverity" class="form-select">
          <option value="">Todas</option>
          <option v-for="item in severities" :key="item" :value="item">{{ item }}</option>
        </select>
        <span class="sep"></span>
        <div class="cell"></div>
      </div>

      <p class="hint">
        El periodo va del inicio del primer día al final del último. La descripción se recorta.
      </p>

      <div class="row actions">
        <div class="cell span-4">
          <button type="submit" class="btn-submit-save" :disabled="isGeneratingReport">
            {{ isGeneratingReport ? 'Generando reporte...' : 'Generar reporte' }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<style scoped>
.nav-bar-operations {
  position: absolute; top: 0; left: 0; width: 100%; height: 10vh;
  background-color: #FFC434; z-index: 1000; margin: 0;
}
.logo-button { position: absolute; height: 90%; top: 50%; left: 50%; transform: translate(-50%, -50%); cursor: pointer; margin: 0; }
.text-operations { margin-top: 10vh; width: 100%; height: 5vh; border-bottom: 1px solid #000; background: #fff; }

.panel-head { margin: 10px 8px 6px; display: flex; align-items: center; gap: 8px; }
.panel-head h3 { font-size: 1.15rem; margin: 0; }
.panel-head img { width: 24px; height: 24px; }

.filters-card{
  --label-w: 200px;
  --ctrl-w: 360px;
  --sep-w: 22px;
  --gap: 8px;
  --h: 36px;
  --fs: 14px;
  --fs-small: 12px;
  --pad-x: 10px;
  --radius: 10px;

  margin: 10px 8px 16px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 10px rgba(0,0,0,.06);
  display: grid; gap: 10px;
}
.filters-card .row{
  display: grid;
  grid-template-columns: var(--label-w) var(--ctrl-w) var(--sep-w) var(--ctrl-w);
  align-items: center;
  gap: var(--gap);
}
.filters-card .row.actions { grid-template-columns: 1fr; }
.filters-card label { font-size: var(--fs); color:#222; white-space: nowrap; }
.filters-card .sep { text-align: center; color:#666; font-size: var(--fs-small); }
.filters-card .hint { margin: 0; color: #666; font-size: var(--fs-small); max-width: 760px; }

.filters-card input[type="text"],
.filters-card input[type="date"],
.filters-card input[type="datetime-local"],
.filters-card select{
  height: var(--h);
  padding: 0 var(--pad-x);
  border: 1px solid #d5d5d5;
  border-radius: var(--radius);
  font-size: var(--fs);
  outline: none; width: 100%;
}
.filters-card input:focus, .filters-card select:focus{
  border-color:#b3b3b3;
  box-shadow:0 0 0 3px rgba(255,196,52,.22);
}

.filters-card .cell{ height:0; }
.filters-card .span-4{ grid-column: 1 / -1; }
.grayed-out{ background:#f5f5f5; color:#999; }

.btn-submit-save{
  padding: 10px 14px; font-size: .95rem; border-radius: 10px;
  background:#FFC434; border:none; cursor:pointer; font-weight:600;
  box-shadow:0 2px 6px rgba(0,0,0,.08);
}
.btn-submit-save:hover{ background:#e6b12e; }
.btn-submit-save:disabled{ opacity: .7; cursor: default; }

@media (max-width: 1200px){
  .filters-card { --ctrl-w: 300px; }
}
@media (max-width: 980px){
  .filters-card { --label-w: 150px; --ctrl-w: 1fr; }
  .filters-card .row { grid-template-columns: var(--label-w) 1fr; }
  .filters-card .sep, .filters-card .row > .cell { display: none; }
}
</style>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { showReportLoading, hideReportLoading } from '@/utils/reportLoading';

export default {
  data() {
    return {
      startDate: '',
      endDate: '',
      unitCategory: '',
      motiveOfService: '',
      cause: '',
      repairSeverity: '',
      categories: [
        { id: 1, label: 'A' },
        { id: 2, label: 'B' },
        { id: 3, label: 'C' },
        { id: 4, label: 'D' },
        { id: 5, label: 'AUXILIO VIAL' },
        { id: 6, label: 'MONTACARGAS' },
        { id: 7, label: 'AYUDANTE' },
        { id: 8, label: 'NO APLICA' },
      ],
      motives: ['Correctivo', 'Preventivo'],
      causes: ['Negligencia', 'Desgaste', 'Colisión o Accidente', 'Mantenimiento', 'Otro (Especificar)'],
      severities: ['Mayor', 'Menor'],
      blockEdit: false,
      isGeneratingReport: false,
    };
  },
  computed: {
    effectiveEndDate() {
      return this.endDate || this.startDate;
    },
  },
  methods: {
    formatToDatetime(date, time) {
      if (!date) return '';
      return `${date}T${time}`;
    },
    backMainPanel() {
      window.location.href = '/main-panel';
    },
    async generateReport() {
      if (this.isGeneratingReport) return;
      if (!this.startDate) {
        Swal.fire({
          icon: 'warning',
          title: 'Falta la fecha',
          text: 'Selecciona la fecha inicial del periodo.',
        });
        return;
      }
      if (this.endDate && this.endDate < this.startDate) {
        Swal.fire({
          icon: 'error',
          title: 'Error de validación',
          text: 'La fecha final debe ser posterior o igual a la fecha inicial.',
        });
        return;
      }

      this.isGeneratingReport = true;
      showReportLoading();
      try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.post(
          `${apiDirectory}/reports/report-unit-maintenance`,
          {
            start_date: this.formatToDatetime(this.startDate, '00:00'),
            end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
            unit_category: this.unitCategory,
            motive_of_service: this.motiveOfService,
            cause: this.cause,
            repair_severity: this.repairSeverity,
          },
          { responseType: 'blob' }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'reporte_mantenimiento_de_unidades.zip');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        let errorMessage = error?.response?.data?.error || error.message;
        const data = error?.response?.data;
        if (data instanceof Blob) {
          try {
            const parsed = JSON.parse(await data.text());
            errorMessage = parsed.error || errorMessage;
          } catch (parseError) {
            errorMessage = error.message;
          }
        }
        Swal.fire({ icon: 'error', title: 'Error Generando Reporte', text: errorMessage });
      } finally {
        this.isGeneratingReport = false;
        hideReportLoading();
      }
    },
  },
};
</script>
